
export const environment = {
  production: true,
  baseURI: '${BASE_URI}',
  dmBackendURI: '${DM_BACKEND_URI}',
  xprtBackendURI: '${XPRT_BACKEND_URI}',
  xrptBackendURI: '${XRPT_BACKEND_URI}',
  xviBackendURI: '${XVI_BACKEND_URI}',
  auditTrailURI: '${AUDIT_TRAIL_URI}',
  ssrURI: '${SSR_URL}',
  ssrEnv: '${SSR_ENV}',
  envName: 'production',
  version: '${BUILD_TAG}',
  deploymentRegion: '${REGION}',
  logLevel: '${LOG_LEVEL}',
  commit: '${COMMIT}',
  branch:  '${BRANCH}',
  disablePermissionCheck: '${DISABLE_PERMISSIONS_CHECK}',
  stage: '${STAGE}',
  ENABLE_SPECIAL_TRANSLATION_SYMBOL: '${ENABLE_SPECIAL_TRANSLATION_SYMBOL}',
};
